import TagsService from '@/services/resourceTags.service';

import { FETCH_TAGS, UPDATE_TAGS } from './tags.actions.types';
import { SET_TAGS, SET_TAGS_LANG_TYPE, SET_ERROR } from './tags.mutations.types';

const state = {
  error: null,
  tags: { es: [], fr: [], en: [], de: [] },
};

const actions = {
  async [FETCH_TAGS]({ commit, state }) {
    try {
      const langs = Object.keys(state.tags);
      const tags = {};
      for (const lang of langs) {
        tags[lang] = await TagsService.fetchResourceTags(lang);
      }
      commit(SET_TAGS, tags);
    } catch (error) {
      commit(SET_ERROR, error);
    }
  },
  async [UPDATE_TAGS]({ commit }, { lang, type, tags }) {
    try {
      const newTags = await TagsService.updateResourceTags(lang, type, tags);
      commit(SET_TAGS_LANG_TYPE, newTags);
    } catch (error) {
      commit(SET_ERROR, error);
    }
  },
};

const mutations = {
  [SET_ERROR](state, error) {
    state.error = error;
  },
  [SET_TAGS](state, tags) {
    state.tags = tags;
    state.error = null;
  },
  [SET_TAGS_LANG_TYPE](state, newTags) {
    const { lang, type, tags } = newTags;
    const tagsLangTypeIndex = state.tags[lang].findIndex((tagsLang) => tagsLang.type === type);
    if (tagsLangTypeIndex > -1) {
      state.tags[lang][tagsLangTypeIndex].tags = [...tags];
    } else {
      state.tags[lang].push(newTags);
    }
    state.error = null;
  },
};

const getters = {
  getTagsByLangAndType: (state) => (lang, type) => {
    const tagsByType = state.tags[lang].find((t) => t.type === type);
    return tagsByType && tagsByType.tags ? tagsByType.tags : [];
  },
};

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations,
};
